import { from, Subject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { fetchDraft } from '../../api/Drafts';
import { useAuthenticateApiCall } from '../hooks/useAuthenticateApiCall';
import { tryLoadLocalDraft } from '../hooks/useLocalDraft';
import { useSubscription } from '../hooks/useSubscription';
import { BusEvent } from './EditorContext';

export const useInitialisation = (
  bus$: Subject<BusEvent>,
  dispatch: (e: BusEvent) => void,
  id: string
) => {
  const authedFetchDraft = useAuthenticateApiCall(fetchDraft);

  useSubscription(
    () =>
      bus$
        .pipe(
          filter((e) => e.type === 'INITIALISE'),
          switchMap(() => {
            const local = tryLoadLocalDraft(id);
            return local ? from([local]) : from(authedFetchDraft(id));
          })
        )
        .subscribe({
          next: (document) => {
            dispatch({ type: 'Document', event: { type: 'INITIALISE', document } });
            dispatch({ type: 'Editor', event: { type: 'FETCHED_DRAFT' } });
          },
          error: (e) => {
            dispatch({ type: 'Notify', event: 'FetchError' });
            dispatch({ type: 'Editor', event: { type: 'FETCH_FAILED' } });
            console.error('Error fetching draft:', e);
          },
        }),
    [bus$, authedFetchDraft, dispatch, id]
  );
};
